import React from "react";
import { RootStateOrAny, useSelector, useDispatch } from "react-redux";
import { Panel } from "office-ui-fabric-react";
import { useTranslation } from "react-i18next";

import { panelS } from "../../../common/styles/panelStyles";
import { toggleSelfEditPanel } from "../../../../config/redux/admins/adminsActions";
import SelfEditForm from "../forms/SelfEditForm";

const SelfEditPanel: React.FC = () => {
  const { t } = useTranslation("admin");
  const dispatch = useDispatch();
  const { selfEditPanelOpen } = useSelector(
    (state: RootStateOrAny) => state.admins
  );

  const dismissPanel = () => {
    dispatch(toggleSelfEditPanel(false));
  };

  return (
    <Panel
      isOpen={selfEditPanelOpen}
      closeButtonAriaLabel={t("nav.close") as string}
      headerText={t("nav.panelProfile") as string}
      onDismiss={dismissPanel}
      type={1}
      styles={panelS}
      isHiddenOnDismiss={false}
    >
      <SelfEditForm />
    </Panel>
  );
};

export default SelfEditPanel;
